import { ReactNode } from 'react';

import cx from 'classnames';

import { translateSentence } from '@cloud-wave/neon-common-lib/app';

import Text from 'lib/common/components/Text';

import usePageProps from '../../../hooks/usePageProps';

import styles from './styles/controlled-container.module.scss';

export const PageContentHeader = () => {
  const { title, subtitle, buttonContainerId } = usePageProps();

  const hasTitle = Boolean(title);
  const hasSubtitle = Boolean(subtitle);

  const titleComponent =
    hasTitle || hasSubtitle ? (
      <div className={styles['page-title']}>
        {hasTitle && <div className={styles['component-title']}>{translateSentence(title)}</div>}
        {hasSubtitle && <Text color={'darkGrey'}>{translateSentence(subtitle)}</Text>}
      </div>
    ) : null;

  return (
    <div className={cx(styles['controlled-container__header'])} data-testid="page-title">
      <div>{titleComponent}</div>
      <div id={buttonContainerId} className={styles['controlled-container__button-container']}></div>
    </div>
  );
};

export const ControlledPageContainer = ({ children }: { children: ReactNode }) => {
  return (
    <div className={cx(styles['controlled-container'])}>
      <PageContentHeader />
      <div className={cx(styles['controlled-container__content'])}>{children}</div>
    </div>
  );
};
